var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradlelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#172554",
    width: "800px",
    height: "800px",
    viewBox: "-4.8 -4.8 41.60 41.60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.8,
    width: 41.6,
    height: 41.6,
    rx: 20.8,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.265 5.735c-2-2-5.068-2-7.068-0.136-0.129 0.136-0.129 0.265-0.129 0.401s0 0.265 0.129 0.401l0.667 0.667c0.136 0.129 0.401 0.129 0.667 0 0.537-0.401 1.068-0.537 1.735-0.537 1.599 0 2.932 1.333 2.932 2.939 0 0.796-0.265 1.463-0.796 2-4 4-9.469-7.204-21.599-1.469-0.803 0.401-1.204 1.333-0.803 2.136v0.129l2 3.599c0.401 0.803 1.469 1.068 2.265 0.667l0.932-0.531c1.068-0.667 2-1.333 2.939-2.136 0.129-0.129 0.531-0.129 0.667 0 0.265 0.136 0.265 0.401 0.129 0.667l-0.129 0.136c-0.939 0.803-2 1.599-3.068 2.265l-0.932 0.401c-0.401 0.265-0.803 0.401-1.333 0.401-0.939 0-1.871-0.537-2.272-1.333l-2-3.469c-3.728 2.667-6.129 7.871-4.796 14.401 0 0.265 0.265 0.401 0.531 0.401h2.265c0.272 0 0.401-0.136 0.537-0.401 0.265-1.864 1.864-3.068 3.735-2.803 1.463 0.136 2.667 1.333 2.796 2.803 0 0.265 0.265 0.401 0.537 0.401h2.129c0.265 0 0.401-0.136 0.537-0.401 0.265-1.864 1.864-3.068 3.728-2.803 1.469 0.136 2.667 1.333 2.803 2.803 0 0.265 0.265 0.401 0.531 0.401h2.136c0.265 0 0.531-0.265 0.531-0.537 0-3.061 0.939-6.531 3.204-8.265 7.864-6.129 5.735-11.333 3.864-13.197zM22 14.932l-1.599-0.796c0-0.537 0.401-0.939 0.932-0.939s0.932 0.401 0.932 0.939c0.136 0.395 0 0.667-0.265 0.796z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradlelogo);
export default __webpack_public_path__ + "static/media/gradlelogo.d93957bffd395717f4714bf5f241af5d.svg";
export { ForwardRef as ReactComponent };